import moment from "moment";

export default function CustomFormat(date: Date, format: string = "DD/MM/YY HH:mm"): string {
	return moment(date).format(format);
}
